import {combineReducers} from 'redux'
import {reducer as formReducer} from 'redux-form'
import answers from './answers'
import respondent from './respondent'
import survey from './survey'
import auth from './auth'

export default combineReducers({
    auth,
    answers,
    respondent,
    survey,
    form: formReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js